/**
 * Shows an HTML element by setting its display style and aria-hidden attribute.
 * @param {HTMLElement | null} el - The element to show.
 * @param {string} [display='block'] - The display style to set.
 */
export const showElement = (
    el: HTMLElement | null,
    display: string = 'block',
): void => {
    if (!el) {
        return;
    }
    el.style.display = display;
    el.setAttribute('aria-hidden', 'false');
};
